import AsyncStorage from '@react-native-async-storage/async-storage';

// Web analytics consent (GDPR/ePrivacy). Deny-default: until the user clicks
// Accept on the banner, the Firebase JS SDK is never initialised and no
// network request is sent to Google Analytics. Stored in AsyncStorage so the
// choice persists across reloads.
//
// Native is unaffected — Crashlytics and the native analytics SDK are
// governed by App Tracking Transparency / Play Store policy and ship
// regardless.

const STORAGE_KEY = 'analytics_consent';

export type ConsentState = 'unknown' | 'accepted' | 'rejected';

export const getConsent = async (): Promise<ConsentState> => {
  try {
    const v = await AsyncStorage.getItem(STORAGE_KEY);
    return v === 'accepted' || v === 'rejected' ? v : 'unknown';
  } catch {
    return 'unknown';
  }
};

export const setConsent = async (state: 'accepted' | 'rejected'): Promise<void> => {
  try {
    await AsyncStorage.setItem(STORAGE_KEY, state);
  } catch {
    /* ignore — worst case the banner shows again next session */
  }
};

export default {};
